export const data = [
    {
        title:"Discover Ethiopia",
        description:"Discover the Hidden Gems of Ethiopia",
        image_url:"https://res.cloudinary.com/dtlrrlpag/image/upload/v1693140578/Eneyat/1_bp2juu.jpg"
    },
    {
        title:"Experience Ethiopia",
        description:"Experience the Rich Culture and History of Ethiopia",
        image_url:"https://res.cloudinary.com/dtlrrlpag/image/upload/v1693222176/Eneyat/E-2_fo4axf.jpg"
    },
    {
        title:"International Leisure Packages",
        description:"Tailored vacation options",
        image_url:"https://res.cloudinary.com/dtlrrlpag/image/upload/v1738642363/Eneyat/ly73nzsbxzwrrgek3jxx.jpg"
    },
    {
        title:"Flight Ticketing",
        description:"Flexible booking, cancellation, and exchanges",
        image_url:"https://res.cloudinary.com/dtlrrlpag/image/upload/v1738646026/Eneyat/ahjz4iumlncxj5wkj4dn.jpg"
    },
    {
        title:"Family Fun",
        description:"Kid-friendly vacation packages",
        image_url:"https://res.cloudinary.com/dtlrrlpag/image/upload/v1693223465/Eneyat/E-6_uxn89i.jpg"
    },
    {
        title:"Exclusive Corporate Deals",
        description:"Dedicated account manager with flexible payment terms",
        image_url:"https://res.cloudinary.com/dtlrrlpag/image/upload/v1738649129/Eneyat/bql0xlovwgyryxfrex5q.jpg"
    },
    {
        title:"Car Rental",
        description:"Reliable vehicles with professional drivers",
        image_url:"https://res.cloudinary.com/dtlrrlpag/image/upload/v1738642899/Eneyat/cnrpp3n4gczlhsr0fono.jpg"
    },
    {
        title:"Rent Camping Gear",
        description:"We offer a rental system for Your Next Adventure",
        image_url:"https://res.cloudinary.com/dtlrrlpag/image/upload/v1693228216/Eneyat/E-8_r4qj9z.jpg"
    }
]